module.exports = __webpack_public_path__ + "img/gs.3326c2af.png";